import request from '@/utils/request'

// 查询NQI服务-标准服务-标准托管服务-检索标准列表
export function listJsbz(query) {
  return request({
    url: '/web/zlts/jsbz/list',
    method: 'get',
    params: query
  })
}

// 查询NQI服务-标准服务-标准托管服务-检索标准详细
export function getJsbz(recid) {
  return request({
    url: '/web/zlts/jsbz/' + recid,
    method: 'get'
  })
}
